// extracted by mini-css-extract-plugin
module.exports = {"newsStory":"NewsIndex-module--newsStory--2HyY4","description":"NewsIndex-module--description--Y00C0","newsMore":"NewsIndex-module--newsMore--1e8cK"};